// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl: 'https://api.dfxonepro.com',
  // ws_url: 'wss://api.nxttrades.com:8443/ws'
  ws_url: 'wss://dfxonepro.com:8443/ws',
  recaptcha: {
    siteKey: '6Ld7rwwlAAAAAEEus28pPS2LkTBpIXA8hTBIHdxV',
  },
};

/*
 // ws_url: 'ws://127.0.0.1:8000/ws/live-data/'
 apiUrl: 'http://stagingwebsites.info:5075',
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
